<template>
  <div class="badge" :style="{ backgroundColor: badge.backgroundColor }">
    <MMText font="Caption S/Medium" :style="{ color: badge.color }">
      {{ badge.label }}
    </MMText>
  </div>
</template>
<script setup lang="ts">
import type { IBadge } from '../../models/badge';
import { MMText } from '@mm-frontend/mm-web-ui-kit';

interface Props {
  badge: IBadge;
}

defineProps<Props>();
</script>
<style lang="stylus" scoped>
.badge
  height 18px
  min-height 18px
  border-radius 10px
  display flex
  align-items center
  justify-content center
  padding 0 4px
</style>
